__turbopack_context__.v({
  "checkYourEmailModal": "CheckYourEmailModal-module__T7BX-q__checkYourEmailModal",
  "h3": "CheckYourEmailModal-module__T7BX-q__h3",
  "h6": "CheckYourEmailModal-module__T7BX-q__h6",
  "submitButton": "CheckYourEmailModal-module__T7BX-q__submitButton",
});
